var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-button",class:{ 'profile-button--mobile': _vm.isMobile },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Ver perfil ")])
}
var staticRenderFns = []

export { render, staticRenderFns }